export default "__VITE_ASSET__0Fu9Zbt2__"